import { useTranslation } from 'react-i18next';
import classes from './Dialog.module.css';
import ReactModal from 'react-modal';
import cn from 'classnames';
import { useTabletAndDownQuery } from '../../hooks/useTabletAndDownQuery.ts';

const Modal = ReactModal as unknown as React.ComponentType<any>;

if (process.env.NODE_ENV !== 'test') ReactModal.setAppElement('#root');

type DialogProps = {
  closeDialog: () => void;
  isOpen: boolean;
  children: React.ReactNode;
};

export const Dialog = ({ isOpen, closeDialog, children }: DialogProps) => {
  const { t } = useTranslation();
  const isTabletAndDown = useTabletAndDownQuery();
  const containerClassNames = cn(classes.modalContainer, {
    [classes.mobileModalContainer]: isTabletAndDown,
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeDialog}
      className={containerClassNames}
      contentLabel={t('dialog.contentLabel')}
      overlayClassName={classes.Overlay}
    >
      {children}
    </Modal>
  );
};
